export default __webpack_public_path__ + "static/media/login.beca66de.svg";